import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@viso/core/guards';
import { LayoutPage } from '@viso/web/vendor/shared/ui/layout';
import { OnBoardGuard } from '@viso/web/vendor/shared/guards';
import { CheckIfModalOpenGuard } from '@viso/core/guards';

const routes: Routes = [
  {
    path: 'welcome',
    loadChildren: () =>
      import('@viso/web/vendor/welcome/feature/welcome').then(
        (m) => m.WelcomePageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@viso/web/vendor/login/feature/login').then((m) => m.LoginModule),
    pathMatch: 'full',
  },
  {
    path: 'register',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@viso/web/vendor/register/feature/register').then(
        (m) => m.RegisterPageModule
      ),
    pathMatch: 'full',
  },
  {
    path: 'registration-details',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('@viso/web/vendor/register/feature/registration-details').then(
        (m) => m.RegistrationDetailsPageModule
      ),
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutPage,
    canActivate: [AuthGuard],
    canActivateChild: [CheckIfModalOpenGuard],
    children: [
      {
        path: 'on-board/services',
        canActivate: [OnBoardGuard],
        loadChildren: () =>
          import('@viso/web/vendor/on-board/shell').then(
            (m) => m.OnBoardShellModule
          ),
      },
      {
        path: 'event',
        loadChildren: () =>
          import('@viso/web/vendor/event/shell').then(
            (m) => m.EventShellModule
          ),
      },
      {
        path: 'feedback',
        loadChildren: () =>
          import('@viso/web/vendor/feedback/shell').then(
            (m) => m.AppSuggestionsShellModule
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('@viso/web/vendor/profile/shell').then(
            (m) => m.ProfileShellModule
          ),
      },
      {
        path: 'notification',
        loadChildren: () =>
          import('@viso/web/vendor/notification/feature/list').then(
            (m) => m.NotificationListPageModule
          ),
      },
      {
        path: 'messaging',
        loadChildren: () =>
          import('@viso/web/vendor/messaging/shell').then(
            (m) => m.MessagingShellModule
          ),
      },
      {
        path: 'terms-and-conditions',
        loadChildren: () =>
          import(
            '@viso/web/vendor/terms-and-conditions/feature/terms-and-conditions'
          ).then((m) => m.TermsAndConditionsModule),
        pathMatch: 'full',
      },
      {
        path: 'privacy-policy',
        loadChildren: () =>
          import('@viso/web/vendor/privacy-policy/feature/privacy-policy').then(
            (m) => m.PrivacyPolicyModule
          ),
        pathMatch: 'full',
      },
      {
        path: 'help',
        loadChildren: () =>
          import('@viso/web/vendor/help/feature/help').then(
            (m) => m.HelpModule
          ),
        pathMatch: 'full',
      },
      {
        path: 'pending-approvals',
        loadChildren: () =>
          import(
            '@viso/web/vendor/pending-approval/feature/pending-approval'
          ).then((m) => m.PendingApprovalModule),
        pathMatch: 'full',
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          import(
            '@viso/web/vendor/contact-us/feature/contact-us'
          ).then((m) => m.ContactUsModule),
        pathMatch: 'full'
      },
      {
        path: 'delete-my-account',
        loadChildren: () =>
          import(
            '@viso/web/vendor/delete-my-account/feature/delete-my-account'
          ).then((m) => m.DeleteMyAccountModule),
        pathMatch: 'full'
      },
      {
        path: '',
        redirectTo: 'on-board/services',
        pathMatch: 'full',
      },
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class VendorShellModule { }
